import { toRGBA } from "../parser/utils";
import { ALIGN_MAPPING } from "../constanst";

export default ({ data }) => {
  const {
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    style,
    color,
    width,
    height,
    align,
  } = data;
  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        display: "flex",
        justifyContent: ALIGN_MAPPING[align],
      }}
    >
      <div
        style={{
          width: `${width}%`,
          borderBottomWidth: height,
          borderBottomStyle: style,
          borderBottomColor: color ? toRGBA(color) : "transparent"
        }}
      />
    </div>
  );
};
